export default __webpack_public_path__ + "static/media/LUMICKO_Header_Logo.a153d5f0.gif";